import type { ClassicSessionProgress } from '../../types'
import { useLocale } from '../../i18n/context'

interface Props {
  progress: ClassicSessionProgress
}

export default function StudyProgress({ progress }: Props) {
  const { tr } = useLocale()
  const cs = tr.classicStudy
  const { total, known, unknown, remaining } = progress
  if (total === 0) return null

  const knownPct = (known / total) * 100
  const unknownPct = (unknown / total) * 100
  const remainingPct = (remaining / total) * 100

  return (
    <div style={{ width: '100%', maxWidth: 640, margin: '0 auto' }}>
      {/* Segmented bar */}
      <div
        style={{
          height: 6,
          borderRadius: 50,
          overflow: 'hidden',
          backgroundColor: 'var(--border)',
          display: 'flex',
        }}
      >
        {known > 0 && (
          <div
            style={{
              width: `${knownPct}%`,
              backgroundColor: 'var(--success)',
              transition: 'width 0.4s ease',
            }}
          />
        )}
        {unknown > 0 && (
          <div
            style={{
              width: `${unknownPct}%`,
              backgroundColor: 'var(--danger)',
              transition: 'width 0.4s ease',
            }}
          />
        )}
        {remaining > 0 && (
          <div
            style={{
              width: `${remainingPct}%`,
              backgroundColor: 'var(--border)',
              transition: 'width 0.4s ease',
            }}
          />
        )}
      </div>

      {/* Labels */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 8,
          fontSize: 12,
          color: 'var(--text-secondary)',
        }}
      >
        <span style={{ color: 'var(--success)' }}>
          {cs.progressKnown(known)}
        </span>
        <span>{cs.progressRemaining(remaining)}</span>
        <span style={{ color: 'var(--danger)' }}>
          {cs.progressUnknown(unknown)}
        </span>
      </div>
    </div>
  )
}
